import { render, staticRenderFns } from "./GDPR.vue?vue&type=template&id=75e6430f"
import script from "./GDPR.vue?vue&type=script&lang=js"
export * from "./GDPR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports